export default __webpack_public_path__ + "static/media/356.d99efc22.png";